<script>

import NavBar from "@/components/general-comp/NavBar.vue";
import SideNavBar from "@/components/general-comp/SideNavBar.vue";

const userInactivityTime = 15 * 60 * 1000; //logout time for inactivity 5 minutes
const tokenRefreshRate = 60000;
let inactivityTime = null;
let tokenRefreshTimer = null;


export default {
  name: "SceneUsr",

  data: () => {
    return {
      navOpen: false,
    }
  },
  components: {
    NavBar,
    SideNavBar,
  },
  created() {
    this.resetInactivityTimeout();
    this.startRenewToken();
  },
  methods: {
    handleActivity() {
      this.resetInactivityTimeout();
    },
    async logout() {

      clearTimeout(inactivityTime);
      clearInterval(tokenRefreshTimer);

      try {
        await this.$api.post('/auth/logout', {});
      } catch (error) {
        console.error('Error logging out:', error);
      } finally {
        this.$router.push("/");
      }
    },
    resetInactivityTimeout() {
      clearTimeout(inactivityTime);
      inactivityTime = setTimeout(this.logout, userInactivityTime);
    },
    startRenewToken() {
      this.renewToken(); // Initial check
      tokenRefreshTimer = setInterval(this.renewToken, tokenRefreshRate);
    },
    async renewToken() {
      try {
        const response = await this.$api.post('/auth/token/refresh', {} );

        if (response.status === 200) {
          return;
        }

        //TODO - alert session expired
        await this.logout();

      } catch (error) {
        console.error('Error renewing token:', error);
      }
    }
  },
  beforeUnmount() {
    clearTimeout(inactivityTime);
    clearInterval(tokenRefreshTimer);
  }

}


</script>

<template>
  <div v-on:mousedown="handleActivity" v-on:keydown="handleActivity" v-on:touchstart="handleActivity" class="noselect">
    <NavBar @togglenav="navOpen = !navOpen" @close="navOpen = false"/>
    <SideNavBar :open="navOpen" @close="navOpen = false"/>

    <div v-if="navOpen" class="overlay" @click.stop="navOpen = false"></div>

    <div class="mainScene">
      <router-view/>
    </div>
  </div>
</template>

<style>

.mainScene {
  position: absolute;
  width: 100%;
  height: calc(100vh - 48px);
  margin-top: 48px;
  overflow: auto;
  margin-bottom: 0;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(255, 255, 255, 0.5); /* semi-transparent */
  backdrop-filter: blur(8px);
}
</style>